import {Directive, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';
import {IFileDocument} from "../../../models/shared.model";

@Directive({
  selector: '[fiDragAndDrop]',
  standalone: false
})
export class DragAndDropDirective {

  @Output() fileDropped = new EventEmitter<IFileDocument>();

  constructor() {}

  @HostListener('drop', ['$event'])
  public onDrop(evt): void {
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
